@if (!isChat) {
  <div>
    <div class="app-container" [class.is-mobile]="mobileQuery.matches">
      <mat-sidenav-container
        class="sidenav-container"
        [class.sidenav-container--framed]="
          profile?.isComplete && !mobileQuery.matches
        "
        [ngClass]="{
          'sidenav-container--mobile-toolbar-active': showMobileToolbar()
        }">
        @if (profile?.isComplete) {
          <mat-sidenav
            [opened]="this.isNavbarOpen || !mobileQuery.matches"
            [mode]="mobileQuery.matches ? 'over' : 'side'"
            [fixedInViewport]="mobileQuery.matches"
            fixedTopGap="56"
            class="navbar w-[22.5rem]">
            <app-navbar
              [userRole]="userRole"
              [schools]="adminSchools"
              [authorities]="adminAuthorities"
              (onNavigate)="toggleNavbar()"
              (onLogout)="logout()"
              (onContextSwitch)="onContextSwitch($event)"
              [profile]="profile"
              [logoutInProgress]="logoutInProgress"
              [showLogo]="!showMobileToolbar()" />
          </mat-sidenav>
        }

        <mat-sidenav-content
          id="scroll-area"
          class="bg-white"
          [class.isChat]="isChat">
          @if (!profileLoading && (!profile || !profile.isComplete)) {
            <div
              class="flex shrink-0 justify-center sticky top-0 z-[10000] bg-white">
              <app-public-toolbar class="w-full" />
            </div>
          }
          <!-- Signed out the footer follows this box, so it must grow with its
               content (min-h-0 would let the list overflow past the footer). -->
          <div
            class="flex w-full min-w-0 flex-1 justify-center"
            [class.min-h-0]="profile?.isComplete">
            <!-- Signed out, the page sits in the same box as the public header
                 and bildigsnetz.ch (max 1512px, gutters 16/32/70/140px). -->
            <div
              class="wrapper w-full flex flex-col justify-between"
              [ngClass]="
                profile?.isComplete ? 'max-w-[1724px]' : 'max-w-[1512px]'
              ">
              <div
                class="flex flex-col gap-4"
                [ngClass]="profile?.isComplete ? 'p-4 md:p-0' : 'py-4 md:py-0'">
                <div
                  id="main-content"
                  [ngClass]="
                    profile?.isComplete
                      ? 'px-0 md:px-16 2xl:px-20'
                      : 'px-4 sm:px-8 lg:px-site-gutter-lg xl:px-site-gutter-xl'
                  ">
                  <app-breadcrumbs />
                  <app-personal-job-search-frame />
                  <div [ngClass]="routerOutletVerticalPaddingClass()">
                    <router-outlet (activate)="onActivate($event)" />
                  </div>
                </div>
              </div>
              @if (profile?.isComplete) {
                <div class="flex flex-col p-4 md:p-0 md:px-16 2xl:px-20">
                  @if (isSchoolProfileRoute) {
                    <div class="flex justify-center">
                      <div class="w-full max-w-[1120px]">
                        <app-footer />
                      </div>
                    </div>
                  } @else {
                    <app-footer />
                  }
                </div>
              }
            </div>
          </div>
          @if (!profile?.isComplete && !isAuthRoute) {
            <!-- Full width like on bildigsnetz.ch. Login, sign-up and password pages have no footer. -->
            <app-public-footer />
          }
        </mat-sidenav-content>
      </mat-sidenav-container>
      @if (showMobileToolbar()) {
        <mat-toolbar
          class="toolbar border-b-2 bg-light-surface-container-low border-none flex justify-between">
          <!-- Tinted circle so the menu reads as a tappable CTA, not a stray glyph. -->
          <button
            mat-icon-button
            class="mobile-menu-button !bg-light-primary-container !text-black !p-2"
            aria-label="Menü öffnen"
            (click)="toggleNavbar()">
            <mat-icon class="material-symbols-rounded">menu</mat-icon>
          </button>
          <a routerLink="/" class="w-32 flex items-center">
            <img src="./assets/logo.svg" alt="Logo" />
          </a>
        </mat-toolbar>
      }
    </div>
  </div>
} @else {
  <mat-sidenav-container
    class="chat"
    [class.chat--framed]="profile?.isComplete && !mobileQuery.matches">
    @if (profile && profile.isComplete) {
      <mat-sidenav
        [opened]="this.isNavbarOpen || !mobileQuery.matches"
        [mode]="mobileQuery.matches ? 'over' : 'side'"
        [fixedInViewport]="mobileQuery.matches"
        fixedTopGap="56"
        class="chat__navbar">
        <app-navbar
          [userRole]="userRole"
          [schools]="adminSchools"
          [authorities]="adminAuthorities"
          (onNavigate)="toggleNavbar()"
          (onLogout)="logout()"
          (onContextSwitch)="onContextSwitch($event)"
          [profile]="profile"
          [logoutInProgress]="logoutInProgress" />
      </mat-sidenav>
    }

    <mat-sidenav-content class="chat__wrapper">
      @if (!profile || !profile.isComplete) {
        <div class="flex grow justify-center">
          <app-public-toolbar class="w-full" />
        </div>
      }
      <section class="chat__wrapper__content">
        <router-outlet />
      </section>
    </mat-sidenav-content>
  </mat-sidenav-container>
}
